import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { kullaniciService } from '../api/dbService';
import PageLayout from '../components/PageLayout';

export default function Profile() {
  const storedUser = JSON.parse(localStorage.getItem('current_user') || '{}');
  const [form, setForm] = useState({ ad_soyad: '', telefon: '', firma: '', adres: '' });
  const [sifre, setSifre] = useState({ mevcut_sifre: '', yeni_sifre: '', yeni_sifre2: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    kullaniciService.getKullanici(storedUser.id).then(res => {
      const u = res.data;
      setForm({ ad_soyad: u.ad_soyad || '', telefon: u.telefon || '', firma: u.firma || '', adres: u.adres || '' });
    }).catch(() => {});
  }, [storedUser.id]);

  async function handleProfil(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await kullaniciService.updateKullanici(storedUser.id, form);
      toast.success('Profil güncellendi');
    } catch { toast.error('Güncelleme başarısız'); }
    finally { setLoading(false); }
  }

  async function handleSifre(e) {
    e.preventDefault();
    if (sifre.yeni_sifre !== sifre.yeni_sifre2) return toast.error('Parolalar eşleşmiyor');
    if (sifre.yeni_sifre.length < 6) return toast.error('En az 6 karakter');
    try {
      await kullaniciService.sifreDegistir(storedUser.id, { mevcut_sifre: sifre.mevcut_sifre, yeni_sifre: sifre.yeni_sifre });
      toast.success('Şifre değiştirildi');
      setSifre({ mevcut_sifre: '', yeni_sifre: '', yeni_sifre2: '' });
    } catch (err) { toast.error(err.response?.data?.message || 'Başarısız'); }
  }

  return (
    <PageLayout>
      <h5 className="mb-3 fw-semibold">Kullanıcı Profili</h5>
      <div className="row g-3">
        <div className="col-12 col-md-6">
          <div className="card">
            <div className="card-header py-2"><small className="fw-semibold">Profil Bilgileri</small></div>
            <div className="card-body">
              <form onSubmit={handleProfil}>
                <div className="mb-2">
                  <label className="form-label small">Email</label>
                  <input className="form-control form-control-sm" value={storedUser.email || ''} disabled />
                </div>
                <div className="mb-2">
                  <label className="form-label small">Rol</label>
                  <input className="form-control form-control-sm" value={storedUser.role || ''} disabled />
                </div>
                {[['ad_soyad', 'Ad Soyad'], ['telefon', 'Telefon'], ['firma', 'Firma'], ['adres', 'Adres']].map(([k, l]) => (
                  <div key={k} className="mb-2">
                    <label className="form-label small">{l}</label>
                    <input
                      className="form-control form-control-sm"
                      value={form[k]}
                      onChange={e => setForm(f => ({ ...f, [k]: e.target.value }))}
                    />
                  </div>
                ))}
                <button type="submit" className="btn btn-brand btn-sm" disabled={loading}>
                  {loading ? 'Kaydediliyor...' : 'Kaydet'}
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6">
          <div className="card">
            <div className="card-header py-2"><small className="fw-semibold">Şifre Değiştir</small></div>
            <div className="card-body">
              <form onSubmit={handleSifre}>
                {[['mevcut_sifre', 'Mevcut Şifre'], ['yeni_sifre', 'Yeni Şifre'], ['yeni_sifre2', 'Yeni Şifre Tekrar']].map(([k, l]) => (
                  <div key={k} className="mb-2">
                    <label className="form-label small">{l}</label>
                    <input
                      type="password"
                      className="form-control form-control-sm"
                      value={sifre[k]}
                      onChange={e => setSifre(s => ({ ...s, [k]: e.target.value }))}
                      required
                    />
                  </div>
                ))}
                <button type="submit" className="btn btn-outline-warning btn-sm">Şifreyi Değiştir</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
